import { Route, RouteGroup } from '@billow/easy-route'

export default RouteGroup({

  middleware: ['guest'], 

  routes: [
    Route('/login', 'login', () => import(`@/views/auth/Login`)),
    Route('/signup', 'signup', () => import(`@/views/auth/Signup`)),
    Route('/security/forgot-password', 'forgot-password', () => import(`@/views/auth/ForgotPassword`)),
    Route('/security/password-reset/:token', 'reset-password', () => import(`@/views/auth/ResetPassword`))
  ]

})
